/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled, { createGlobalStyle, ThemeProvider } from "styled-components"
import normalize from "normalize.css"
import Helmet from "react-helmet"
import { darken, lighten } from "polished"

import Header from "./header"
import theme from "../theme"
import Footer from "./Footer"
import Menu from "./menu"
import CookieBanner from "./CookieBanner"
import onlineDeposits from "../assets/images/online-deposits.jpg"

export const GlobalStyle = createGlobalStyle`
  ${normalize}
  * {
    box-sizing: border-box;
  }
  html {
    font-size: 16px;
    line-height: 1.25;
    @media only screen and (min-width: 700px) {
      font-size: 20px;
    }
  }
  body, html {
    color: #5f636f;
  }
  main {
    overflow-x: hidden;
  }
  body, button, input, select, textarea {
    font-family: "Heebo", sans-serif;
    font-weight: 400;
  }
  h1, h2, h3, h4, h5, h6 {
    color: ${({ theme }) => theme.colors.obsidian};
    font-family: "Fira Sans", sans-serif;
    font-weight: 600;
    clear: both;
    word-wrap: break-word;
    overflow-wrap: break-word;
    margin-top: 0;
    margin-bottom: 1rem;
    &.light {
      color: #fff;
    }
  }
  h1 {
    transition: font-size .5s ease-in-out;
    font-size: 2rem;
    font-weight: 900;
    letter-spacing: .02em;
    text-transform: uppercase;
    @media only screen and (min-width: 700px) {
      font-size: 2.25rem;
    }
  }
  .h1-sub {
    font-family: "Heebo", sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.4;
    &.light {
      color: ${({ theme }) => lighten(0.1, theme.colors.grey1)};
    }
  }
  h2, .h2 {
    font-size: 1.75rem;
    @media only screen and (min-width: 700px) {
      font-size: 2rem;
    }
  }
  h3, .h3 {
    font-size: 1.5rem;
    @media only screen and (min-width: 700px) {
      font-size: 1.75rem;
    }
  }
  h4, .h4 {
    font-size: 1.25rem;
    @media only screen and (min-width: 700px) {
      font-size: 1.5rem;
    }
  }
  h5, .h5 {
    font-size: 1.1rem;
    @media only screen and (min-width: 700px) {
      font-size: 1.25rem;
    }
  }
  a {
    text-decoration: none;
  }
  p {
    margin: 0 0 1rem 0;
    line-height: 1.4;
    &.light {
      color: ${({ theme }) => theme.colors.grey1};
    }
  }
  li {
    margin-bottom: 1rem;
  }

.btn {
  display: inline-flex;
  font-size: 14px;
  font-weight: 700;
  padding: 1rem 2.25rem;
  text-transform: uppercase;
  color: #F9FAFF;
  background-color: ${({ theme }) => theme.colors.blue};
  border-width: 1px;
  border-style: solid;
  border-color: rgba(0,0,0,0);
  border-radius: 2px;
  cursor: pointer;
  justify-content: center;
  text-align: center;
  letter-spacing: inherit;
  white-space: nowrap;
  transition: background .15s ease;
  :hover {
    background-color: #4678f9;
  }
}
.btn-secondary {
  color: ${({ theme }) => theme.colors.blue};
  background-color: #e9ecf3;
  :hover {
    background-color: #fff;
  }
}
.heading {
  max-width: 800px;
  margin: 4rem auto;
  text-align: center;
  .secondary {
    font-size: 20px;
    color: ${({ theme }) => theme.colors.grey4}
  }
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  @media only screen and (min-width: 500px) {
    padding: 0 2rem;
  }
}
.text-center {
  text-align: center;
}
.mb-4 {
  margin-bottom: 4rem;
}
`

const StyledNotifier = styled.div`
  padding: 4rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: rgb(2, 0, 36);
  background: linear-gradient(
    60deg,
    ${({ theme }) => theme.colors.blue} 0%,
    ${({ theme }) => darken(0.2, theme.colors.blue)} 100%
  );
  h2 {
    color: #fff;
  }
`

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  const [pageScrolled, setPageScrolled] = useState(false)
  useEffect(() => {
    window.onscroll = () => {
      if (window.scrollY > 50) {
        setPageScrolled(true)
      } else if (window.scrollY < 10) {
        setPageScrolled(false)
      }
    }
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css?family=Fira+Sans:400,600,700,800,900|Heebo:400,700&display=swap"
          rel="stylesheet"
        />
        <meta property="og:image" content={onlineDeposits} />
      </Helmet>
      <GlobalStyle />
      <StyledNotifier>
        <div>
          <h2>DEALER 9000 IS NOW DEALERSHIP.CO.UK</h2>
          <a href="https://dealership.co.uk" className="btn btn-secondary">
            Visit our new home
          </a>
        </div>
      </StyledNotifier>
      <div>
        <Menu pageScrolled={pageScrolled} />
        <div id="page-wrap">
          <Header
            siteTitle={data.site.siteMetadata.title}
            pageScrolled={pageScrolled}
          />
          <main>{children}</main>
          <Footer />
          <CookieBanner />
        </div>
      </div>
    </ThemeProvider>
  )
}

export default Layout
